/* import __COLOCATED_TEMPLATE__ from './detect-categories.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type AppService from 'embercom/services/app-service';

interface Signature {
  Element: HTMLDivElement;
  Args: { accordion: $TSFixMe; categoriesCount: number };
}

export default class DetectCategories extends Component<Signature> {
  @service declare appService: AppService;

  get manageCategoriesRoute() {
    return this.appService.app.isStandaloneApp
      ? 'apps.app.standalone.attributes'
      : 'apps.app.automation.fin-ai-agent.attributes';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::DetectCategories': typeof DetectCategories;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/detect-categories': typeof DetectCategories;
  }
}
